export const FETCH_LIST_PROMOTION_SUCCESS = "FETCH_LIST_PROMOTION_SUCCESS";
export const FETCH_DETAIL_PROMOTION_SUCCESS = "FETCH_DETAIL_PROMOTION_SUCCESS";
export const FETCH_DELETE_DETAIL_PROMOTION_SUCCESS =
  "FETCH_DELETE_DETAIL_PROMOTION_SUCCESS";
